module.exports = __webpack_public_path__ + "images/banners/company_recruitment/banner_bbec9d15205b8d3001ee482a056ddf27.jpg";